import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationModule } from './authentication/authentication.module';
import { BaseModule } from './base/base.module';
import { httpInterceptorProviders } from './shared/interceptors';
import { FieldFormatterPipe } from './shared/pipes/field-formatter.pipe';
import { SUPPORTED_LANGUAGES } from './shared/services/translation/supported-languages';
import { LOCAL } from './shared/services/storage/local.enum';
import { StorageService } from './shared/services/storage/storage.service';
import { TranslateService } from '@ngx-translate/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInitializerFactory(
  translate: TranslateService
) {
  return async () => {
    translate.addLangs(Object.values(SUPPORTED_LANGUAGES).map(lang => lang.locale));
    const storedLocale = localStorage.getItem(LOCAL.LOCALE) ? JSON.parse(localStorage.getItem(LOCAL.LOCALE)) : null;

    if (storedLocale) {
      return await translate.use(storedLocale);
    } else {
      localStorage.setItem(LOCAL.LOCALE, JSON.stringify(SUPPORTED_LANGUAGES.PT.locale));
      return await translate.use(SUPPORTED_LANGUAGES.PT.locale);
    }
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BaseModule, // Eager Loaded Module
    AuthenticationModule, // Eager Loaded Module
    HttpClientModule,
    BrowserAnimationsModule,
  
    ToastrModule.forRoot({
      timeOut: 8000,
      preventDuplicates: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    httpInterceptorProviders, DatePipe, DecimalPipe, FieldFormatterPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
